"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ReportDisplay;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
const ReportComponent_1 = __importDefault(require("@/components/pbi/ReportComponent"));
const configService_1 = require("@/service/configService");
const reportService_1 = require("@/service/reportService");
const powerbiUtils_1 = require("@/utils/powerbiUtils");
const react_1 = require("react");
const ErrorDisplay_1 = __importDefault(require("./ErrorDisplay"));
function ReportDisplay(props) {
    const { className, reportCode, workspaceId, reportId, bookmark, onReportLoaded, onButtonClicked, children } = props, others = __rest(props, ["className", "reportCode", "workspaceId", "reportId", "bookmark", "onReportLoaded", "onButtonClicked", "children"]);
    const classes = `${className ? className : ""}`;
    (0, react_1.useEffect)(() => {
        console.log("embedReport bookmark: " + bookmark);
        embedReport();
    }, []);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const [isReportRendered, setReportRendered] = (0, react_1.useState)(false);
    const [reportEmbedConfig, setReportEmbedConfig] = (0, react_1.useState)({
        id: undefined,
        embedUrl: undefined,
        accessToken: undefined,
    });
    let reportDefinition = null;
    const embedReport = () => __awaiter(this, void 0, void 0, function* () {
        try {
            if (reportCode) {
                reportDefinition = (0, configService_1.getReportDefinition)(reportCode);
                if (reportDefinition === null) {
                    throw new Error(`Report not configured (code=${reportCode}).`);
                }
            }
            else if (workspaceId && reportId) {
                reportDefinition = { workspaceId, reportId, code: "", name: "" };
            }
            else {
                throw new Error("Fehler: Entweder <reportCode> ODER <workspaceId> und <reportId> angegeben.");
            }
            const response = yield (0, reportService_1.getReportEmbedInfo)(reportDefinition.reportId, reportDefinition.workspaceId);
            setReportEmbedConfig(Object.assign(Object.assign({}, reportEmbedConfig), { embedUrl: response.embedUrl, accessToken: response.accessToken, bookmark: { name: bookmark ? bookmark : "" } }));
        }
        catch (error) {
            const serviceError = error;
            console.log(serviceError);
            setErrorMessage(serviceError.message);
        }
    });
    const _onReportLoaded = (report) => __awaiter(this, void 0, void 0, function* () {
        // set report page, if configured 
        if (report && (reportDefinition === null || reportDefinition === void 0 ? void 0 : reportDefinition.pageName)) {
            try {
                yield (0, powerbiUtils_1.setReportPage)(report, reportDefinition === null || reportDefinition === void 0 ? void 0 : reportDefinition.pageName);
            }
            catch (error) {
                console.log(error);
                throw error;
            }
        }
        // delegate to callback, if specified
        if (onReportLoaded) {
            onReportLoaded(report);
        }
    });
    const _onReportRendered = () => {
        //console.log(`Report rendered: ${reportDefinition?.code}`);
        setReportRendered(true);
    };
    const _onButtonClicked = (event) => {
        if (onButtonClicked) {
            onButtonClicked(event);
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: errorMessage ? (0, jsx_runtime_1.jsx)(ErrorDisplay_1.default, { message: errorMessage }) :
            (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ReportComponent_1.default, { className: classes, reportConfiguration: reportEmbedConfig, onReportLoaded: _onReportLoaded, onReportRendered: _onReportRendered, onButtonClicked: _onButtonClicked }) }) }));
}
